import { Injectable } from '@angular/core';
import { ApiService, PreviewAcertoPonto, ResultadoAcertoPonto } from '../../api.service';

@Injectable({ providedIn: 'root' })
export class ServicoAcertoPonto {
  constructor(private readonly api: ApiService) {}

  preview(
    empregadorId: string,
    dataInicial: string,
    dataFinal: string,
    funcionarioId?: string,
    departamentoIds?: string[]
  ) {
    return this.api.previewAcertoPonto(empregadorId, dataInicial, dataFinal, funcionarioId, departamentoIds);
  }

  aplicar(
    empregadorId: string,
    dataInicial: string,
    dataFinal: string,
    eventoIds: string[],
    funcionarioId?: string,
    departamentoIds?: string[]
  ) {
    return this.api.aplicarAcertoPonto(empregadorId, dataInicial, dataFinal, eventoIds, funcionarioId, departamentoIds);
  }

  mensagemEmpregadorObrigatorio() {
    return 'Selecione um empregador para o acerto de ponto.';
  }

  mensagemServidorObrigatorio() {
    return 'Selecione um servidor para o acerto individual.';
  }

  mensagemSelecaoObrigatoria() {
    return 'Selecione ao menos um candidato para confirmar o acerto.';
  }

  mensagemErroPreview() {
    return 'Nao foi possivel montar o preview de acerto.';
  }

  mensagemErroAplicar() {
    return 'Nao foi possivel gravar o acerto de ponto.';
  }

  resumo(preview: PreviewAcertoPonto) {
    return `${preview.candidatos.length} candidato(s) e ${preview.ignorados.length} ignorado(s).`;
  }

  resumoAplicacao(resultado: ResultadoAcertoPonto) {
    return `Acerto concluido: ${resultado.gravados} gravado(s), ${resultado.jaAplicados} ja aplicado(s), ${resultado.recusados} recusado(s).`;
  }
}
